import { useContext, useEffect, useState } from "react";
import AppTable from "../table/AppTable";
import { useLazyQuery } from "@apollo/client";
import { GET_SOLD_TICKETS, GET_SOLD_TICKETS_BY_LOGITIXUSER } from "../../../features/Tickets/api/TicketsQuery";
import ToasterWithMessage from "../toaster";
import { globalContext } from "../../../Provider/AppProvider";
import { CircularProgress } from "@mui/material";
import styles from '../../../features/Users/Users.module.css'
import { roles } from "../../../helper";

const SoldTickets = (props: any) => {
  const {
    rowsPerPage,
    currentPage,
    setCurrentPage,
    checking,
    setChecking,
    soldTicketList,
    setsoldTicketList,
    selected,
    setSelected,
    columnTypes,
    setColumnTypes,
    sortType,
    setSortType,
    GenerateSoldTicketHeadCells,
    handleChangeRowsPerPage,
    handlePageChange,
    activeTab,
  } = props;
  const { error } = ToasterWithMessage();
  const { globalState, handleGlobalState } = useContext<any>(globalContext);
  const [searchvalue, setSearchvalue] = useState(
    globalState?.globalSearch?.searchtext
  );

  useEffect(() => {
    const tempdata = { ...globalState };
    setSearchvalue(tempdata?.globalSearch?.searchtext);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.globalSearch?.searchtext]);

  const [getSoldTickets, { loading }] = useLazyQuery(GET_SOLD_TICKETS, {
    fetchPolicy: "no-cache",
    onCompleted: (soldTicketsData) => {
      setsoldTicketList(soldTicketsData);
      const tempState = {...globalState};
      tempState.soldTicketFilter.clicked = false;
      if(globalState.notification.notificationClicked){
      tempState.manageTicketFilter.notificationFilterDataCount = soldTicketsData?.filtermanagetickets_aggregate?.aggregate?.count;
      tempState.listTicketFilter.notificationFilterDataCount = soldTicketsData?.filterlisttickets_aggregate?.aggregate?.count;
      tempState.soldTicketFilter.notificationFilterDataCount = soldTicketsData?.FilterSoldTickets_aggregate?.aggregate?.count;
      tempState.delistAndReturnTicketFilter.notificationFilterDataCount = soldTicketsData?.filterreturntickets_aggregate?.aggregate?.count;
      tempState.unsoldTicketFilter.notificationFilterDataCount = soldTicketsData?.filterUnsoldTickets_aggreagate?.aggregate?.count;
    }if(globalState.error.errorClicked){
      tempState.manageTicketFilter.errorFilterDataCount = soldTicketsData?.filtermanagetickets_aggregate?.aggregate?.count;
      tempState.listTicketFilter.errorFilterDataCount = soldTicketsData?.filterlisttickets_aggregate?.aggregate?.count;
      tempState.soldTicketFilter.errorFilterDataCount = soldTicketsData?.FilterSoldTickets_aggregate?.aggregate?.count;
      tempState.delistAndReturnTicketFilter.errorFilterDataCount = soldTicketsData?.filterreturntickets_aggregate?.aggregate?.count;
      tempState.unsoldTicketFilter.errorFilterDataCount = soldTicketsData?.filterUnsoldTickets_aggreagate?.aggregate?.count;
    }
      handleGlobalState(tempState)
    },
    onError: () => {
      error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    },
  });

  const [getSoldTicketsByLogitix, { loading:logitixLoading }] = useLazyQuery(GET_SOLD_TICKETS_BY_LOGITIXUSER, {
    fetchPolicy: "no-cache",
    onCompleted: (soldTicketsDataForLogitix) => {
      setsoldTicketList(soldTicketsDataForLogitix);
      const tempState = {...globalState};
      tempState.soldTicketFilter.clicked = false;
      if(globalState.notification.notificationClicked){
      tempState.manageTicketFilter.notificationFilterDataCount = soldTicketsDataForLogitix?.filtermanagetickets_aggregate?.aggregate?.count;
      tempState.listTicketFilter.notificationFilterDataCount = soldTicketsDataForLogitix?.filterlisttickets_aggregate?.aggregate?.count;
      tempState.soldTicketFilter.notificationFilterDataCount = soldTicketsDataForLogitix?.FilterSoldTickets_aggregate?.aggregate?.count;
      tempState.delistAndReturnTicketFilter.notificationFilterDataCount = soldTicketsDataForLogitix?.filterreturntickets_aggregate?.aggregate?.count;
      tempState.unsoldTicketFilter.notificationFilterDataCount = soldTicketsDataForLogitix?.filterUnsoldTickets_aggreagate?.aggregate?.count;
    }if(globalState.error.errorClicked){
      tempState.manageTicketFilter.errorFilterDataCount = soldTicketsDataForLogitix?.filtermanagetickets_aggregate?.aggregate?.count;
      tempState.listTicketFilter.errorFilterDataCount = soldTicketsDataForLogitix?.filterlisttickets_aggregate?.aggregate?.count;
      tempState.soldTicketFilter.errorFilterDataCount = soldTicketsDataForLogitix?.FilterSoldTickets_aggregate?.aggregate?.count;
      tempState.delistAndReturnTicketFilter.errorFilterDataCount = soldTicketsDataForLogitix?.filterreturntickets_aggregate?.aggregate?.count;
      tempState.unsoldTicketFilter.errorFilterDataCount = soldTicketsDataForLogitix?.filterUnsoldTickets_aggreagate?.aggregate?.count;
    }
      handleGlobalState(tempState)
    },
    onError: () => {
      error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    },
  });

  useEffect(() => {
    if ((activeTab === 2) || (globalState?.payoutTicket?.payment === true) || (globalState?.loadingForVoidedPayout.voidedPayoutLoader === true)) {
      const soldTicketsVariables={
        startdate:  globalState?.notification?.notificationClicked ? null: globalState?.soldTicketFilter?.startdate
          ? globalState?.soldTicketFilter?.startdate
          : globalState?.soldTicketFilter?.startDateRange,
        enddate:  globalState?.notification?.notificationClicked ? null: globalState?.soldTicketFilter?.enddate
          ? globalState?.soldTicketFilter?.enddate
          : globalState?.soldTicketFilter?.endDateRange,
        leagueId:  globalState?.notification?.notificationClicked ? null: globalState?.soldTicketFilter?.leagueId,
        paymentStatus:  globalState?.notification?.notificationClicked ? null: globalState?.soldTicketFilter?.paymentStatus,
        payoutType: globalState?.notification?.notificationClicked ? null: globalState?.soldTicketFilter?.payoutType,
        pageSize: rowsPerPage,
        pageOffset: (currentPage - 1) * rowsPerPage,
        order_by: [{ [columnTypes]: sortType }, {"tp_id": "asc"}],
        search_event:searchvalue === globalState.notification.text ?"%":searchvalue === globalState.error.text?"%":`${searchvalue}%`,
        ticketId:globalState.notification.ticketId,
        ticketPlacementId: globalState.notification.tpId,
        array_tpid:globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };
      
      if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN || globalState.profile.userRole === roles.SUPER_USER)){
      getSoldTickets({
        variables: soldTicketsVariables
      });
    }else{
      getSoldTicketsByLogitix({
        variables:soldTicketsVariables
      });
    }
    }
    const tempState = { ...globalState };
    tempState.payoutTicket.payment = false;
    tempState.loadingForVoidedPayout.voidedPayoutLoader = false;
    handleGlobalState(tempState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeTab,
    rowsPerPage,
    currentPage,
    sortType,
    columnTypes,
    searchvalue,
    globalState?.globalSearch?.searchtext,
    getSoldTickets,
    globalState?.payoutTicket?.payment,
    globalState.notification.notificationSearchCancel,
    globalState?.loadingForVoidedPayout?.voidedPayoutLoader
  ]);

  useEffect(() => {
    if (globalState.soldTicketFilter.clicked) {
      const getSoldTicketsVariables={
        startdate: globalState?.soldTicketFilter?.startdate
          ? globalState?.soldTicketFilter?.startdate
          : globalState?.soldTicketFilter?.startDateRange,
        enddate: globalState?.soldTicketFilter?.enddate
          ? globalState?.soldTicketFilter?.enddate
          : globalState?.soldTicketFilter?.endDateRange,
        leagueId: globalState?.soldTicketFilter?.leagueId,
        paymentStatus: globalState?.soldTicketFilter?.paymentStatus,
        payoutType: globalState?.soldTicketFilter?.payoutType,
        pageSize: rowsPerPage,
        pageOffset: (currentPage - 1) * rowsPerPage,
        order_by: [{ [columnTypes]: sortType },{"tp_id": "asc"}],
        search_event: `${searchvalue}%`,
        ticketId:globalState.notification.ticketId,
        ticketPlacementId: globalState.notification.tpId,
        array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

      if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
      getSoldTickets({
        variables:getSoldTicketsVariables
      });
    }else{
      getSoldTicketsByLogitix({
        variables: getSoldTicketsVariables
      });
    }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getSoldTickets,
    globalState.soldTicketFilter.clicked
  ]);
  return (
    <div>
      {
        (loading || logitixLoading || globalState?.loadingForAutoPayout?.AutoPayoutLoader || globalState?.loadingForVoidedPayout?.voidedPayoutLoader)
      ? 
          <div className={styles.TableCircularProgress}>
          <CircularProgress color="primary" size={35} />
          </div>
      :
            <AppTable
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handlePageChange={handlePageChange}
              setColumnTypes={setColumnTypes}
              sortType={sortType}
              setSortType={setSortType}
              setSelected={setSelected}
              setChecking={setChecking}
              checking={checking}
              selected={selected}
              rowsPerPage={rowsPerPage}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              list={soldTicketList}
              tableTitle="soldTickets"
              generateHeadCells={GenerateSoldTicketHeadCells}
            />
      }
    </div>
  );
};

export default SoldTickets;
